import React, { useContext, useState, useEffect } from 'react'
import { ActivityLogContext } from 'activity/ducks/index'
import Layout from 'common/components/Layout'
import ProgramDialog from 'activity/components/ProgramDialog'
import ProgramCalendar from 'activity/components/ProgramCalendar'
import useActivity from 'activity/hooks/useActivity'
import ProgramCards from 'activity/components/ProgramCards'
import { UserContext } from 'account'
import { useLocation } from 'react-router-dom'
import { DialogContentText, DialogContent, Dialog } from '@mui/material'
import ActivityDialog from 'activity/components/Dialog'
import useApi from 'common/hooks/useApi'
import { LayoutContext } from 'common/ducks/index'
import BackdropLoader from 'common/components/BackdropLoader'

function Activity() {
  const user = useContext(UserContext)
  const [planName, setPlanName] = useState('')
  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const queryParams = new URLSearchParams(window.location.search)
  const paymentStatus = queryParams.get("state")
  const location = useLocation()
  const { loading, data, state, dispatch, openProgramDialog, programList } =
    useActivity()

    const [{ data: subscriptionsData = {} }] =  useApi('subscriptions/')

    if (location.pathname === '/' && user.isTrainer) {
      if (paymentStatus === 'succeeded'){
        window.location.href = '/trainerDashboard?state=succeeded'
      } else {
         window.location.href = '/trainerDashboard'
      }
    }

    useEffect(() => {
      if (paymentStatus === 'succeeded') {
        if (subscriptionsData.subscriptions) {
          const subscription = subscriptionsData.subscriptions?.find((s) => s.status === 'active' || 'trialing')
          if (subscription) {
            setShowPaymentModal(true)
            setPlanName(programList[0]?.name)
          }
        }
      }
    }, [subscriptionsData.subscriptions, programList])
  return (
    <ActivityLogContext.Provider value={{ state, dispatch }}>
      <Layout>
        <ProgramCalendar loading={loading} data={data} />
        <ProgramCards programList={programList} onClick={openProgramDialog} />

        <ActivityDialog />
        <ProgramDialog />
        <BackdropLoader open={loading} />
      </Layout>
      <Dialog open={showPaymentModal} onClose={() => setShowPaymentModal(false)} >
        <DialogContent style={{height: '45rem', width: '23rem'}}>
          <DialogContentText>
          <>
            <strong style={{ fontWeight: 'bolder' }}>
              Welcome to Sidekick!
            </strong>
            <br />
            <br />
            <strong style={{ fontWeight: 'bolder' }}>
              Subscription added!
            </strong>
            <br />
            <br />
            {!user.isTrainer && planName &&(
            <div>
              {planName} has been added to your Program page
            </div>
            )}
            <br />
            <strong style={{ fontWeight: 'bolder' }}>
              You now have access to the platform
            </strong>
            <br />
            <br />
            Watch this to help get started
            <br />
            <br />
            <iframe title='Welcome Video' style={{height: '25rem', width: '18rem'}} loading="lazy"src="https://app.storylane.io/demo/vsovgx2wz2aj?embed=popup" name="sl-embed" allow="fullscreen" allowfullscreen/>
            </>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </ActivityLogContext.Provider>
  )
}

export default Activity
